import { createRouter, createWebHashHistory } from 'vue-router';
import { isSafari } from '@/infrastructure/utils/browser';
import { isUserLogin } from '@eureka/utils/account';
import { loadI18n } from '@/infrastructure/locales';
import { useVisitorCookies } from '@/composables/home/use-visitor-cookies';

const { initVisitorCookies } = useVisitorCookies();

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home',
      beforeEnter: async (to, from, next) => {
        await loadI18n();
        const is_login = await isUserLogin();
        if (!is_login) {
          initVisitorCookies();
          next();
          return;
        }
        if (isSafari()) {
          next({ name: 'upgrade' });
          return;
        }
        next();
      },
      children: [
        {
          path: '/home',
          name: 'MainHomePage',
          component: () => import('@/components/home/TheMainHomePage.vue'),
          children: [
            {
              path: 'success-payment',
              name: 'SuccessPayment',
              component: () => import('@/components/home/TheMainHomePage.vue'),
              beforeEnter: () => {
                router.push({
                  name: 'MainHomePage',
                  query: {
                    payment_state: 'success',
                  },
                });
              },
            },
          ],
        },
        {
          name: 'mse-doc-analyzer-result',
          path: '/material/analyzer/:lsAgentId',
          component: () => import('@/components/pages/doc-analyzer/MSEDocAnalyzer.vue'),
        },
        {
          name: 'TechQa',
          path: '/chat',
          children: [
            {
              name: 'TechQaConversation',
              path: ':conversation_id',
              component: () => import('@/components/pages/tech-qa/ConversationPage.vue'),
            },
          ],
        },
        {
          name: 'Formulation',
          path: '/formulation',
          children: [
            {
              name: 'FormulationConversation',
              path: ':session_id',
              component: () => import('@/components/pages/formulation/ConversationPage.vue'),
            },
          ],
        },
        {
          name: 'Guest',
          path: '/shared',
          children: [
            {
              name: 'GuestTechQaConversation',
              path: 'chat/:conversation_id',
              component: () => import('@/components/pages/tech-qa/ConversationPage.vue'),
              props: () => ({
                guest: true,
              }),
            },
            {
              name: 'GuestFormulationConversation',
              path: 'formulation/:session_id',
              component: () => import('@/components/pages/formulation/ConversationPage.vue'),
              props: () => ({
                guest: true,
              }),
            },
          ],
        },
        {
          path: '/gallery',
          name: 'CommunityGallery',
          component: () => import('@/components/pages/community/CommunityGalleryPage.vue'),
        },
        {
          path: '/subscribe',
          name: 'SubscriptionLinkPage',
          component: () => import('@/components/pages/subscription/SubscriptionLinkPage.vue'),
        },

        // OLD
        {
          path: '/old-home',
          name: 'OldHome',
          component: () => import('@/components/pages/home/MSE.vue'),
        },
        {
          name: 'GeneralSearch',
          path: '/general-search',
          component: () => import('@/components/pages/general-search/index.vue'),
        },
        {
          name: 'SubstanceSearch',
          path: '/substance',
          component: () => import('@/components/pages/substance/index.vue'),
        },
        {
          name: 'StructureSearch',
          path: '/structure',
          component: () => import('@/components/pages/structure/index.vue'),
        },
        {
          name: 'Workflow',
          path: '/workflow',
          component: () => import('@/components/pages/workflow/index.vue'),
        },
        {
          name: 'PropertySearch',
          path: '/property',
          component: () => import('@/components/pages/property/index.vue'),
        },
        {
          name: 'CompositionSearch',
          path: '/composition',
          component: () => import('@/components/pages/composition/index.vue'),
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log('Global Route Guard:', {
    step: 'beforeEach',
    to: {
      path: to.path,
      name: to.name,
      params: to.params,
      meta: to.meta,
    },
    from: {
      path: from.path,
      name: from.name,
    },
    matched: to.matched.map((record) => ({
      path: record.path,
      name: record.name,
    })),
  });
  next();
});

export { router };
export default router;
